import { render } from "./autograph.vue?vue&type=template&id=4ee80602"
import script from "./autograph.vue?vue&type=script&lang=js"
export * from "./autograph.vue?vue&type=script&lang=js"

import "./autograph.vue?vue&type=style&index=0&id=4ee80602&lang=css"

import exportComponent from "C:\\Project\\VuePro\\classCloud\\kclass-index-mtzls\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__